import Slider from "react-slick";
import { useEffect, useState } from 'react'
import { RootState } from "../../../../setup/redux/RootReducer";
import { useDispatch, useSelector } from 'react-redux'
import { PageTitle } from '../../../../_metronic/layout/core';
import { Link, useHistory, useLocation } from "react-router-dom";
import { useApolloClient } from "@apollo/client"
import { DocumentRelations, Product, ProductNode, ProductTag } from '../../../types'
import { GET_PRODUCTS_BY_TAGTEXT } from "../../../store/queries";
import { setMainLoading } from "../../../../setup/redux/loadingSlice";


export default function ProductTagPage() {

    let images: any = {};
    images["no"] = "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Logo_METRO.svg/1200px-Logo_METRO.svg.png";

    const location = useLocation();
    const history = useHistory();
    const search = location.search;
    let _tagText = new URLSearchParams(search).get('ProductTag');

    const client = useApolloClient();
    const dispatch = useDispatch()

    const [productsModel, setProductsModel] = useState<ProductNode[] | undefined>([]);

    var productTemp: ProductNode[] | undefined = [];
    var cursor: (string | undefined) = undefined;


    async function getList(): Promise<any> {
        return await client.query({
            query: GET_PRODUCTS_BY_TAGTEXT,
            variables: { cursor: cursor, tagText: _tagText }
        }).then(resp => {
            console.log("product model  => ", resp);
            if (resp.error) {
                return false;
            }
            else {
                try {
                    const pi = resp.data.products.pageInfo;
                    productTemp?.push(...resp.data.products.edges);
                    cursor = pi.endCursor;
                    return pi.hasNextPage;

                } catch (err) {
                    console.log("burada => ", err);
                }
            }
        }).catch((err: any) => {
            console.log("error activity list => ", err);
            return false;
        });
    }

    async function startWhile(hasMore: boolean) {
        while (hasMore) {
            dispatch(setMainLoading(true))
            hasMore = await getList();
            console.log("Deneme 71", productTemp)
            // setProductsModel(productTemp);
        }
        dispatch(setMainLoading(false));
        setProductsModel(productTemp);
        console.log("ProducTemp =>>", productTemp)
    }

    useEffect(() => {
        setProductsModel([]);
        startWhile(true);
    }, []);



    const getProductImage = (documentRelationList: DocumentRelations[] | undefined) => {
        if (documentRelationList == undefined || documentRelationList.length == 0) {
            return images["no"];
        }

        return documentRelationList[0].document.fileName;
    }

    return (
        <>
            <div className='card card-stretch mb-5 mb-xxl-8'>
                <div className='card-body'>
                    <div className=''>
                        <h1 className='mb-5' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignContent: 'flex-end', justifyContent: 'flex-start', alignItems: 'center' }}>
                        </h1>
                        <div className='row mt-15'>
                            <h2 style={{ display: productsModel != undefined && productsModel.length > 0 ? 'block' : 'none' }}>
                                Ürünler({productsModel?.length})
                            </h2>
                            {productsModel?.map(x =>
                                <div className='col-md-4 mb-6' key={x.node.guid}>
                                    <div className='card-xl-stretch'>
                                        <Link className='d-block overlay mb-4'
                                            to={'/productDetail?guid=' + x.node.guid}
                                        // onClick={() => updateBreadCrump()}
                                        >
                                            <div
                                                className='overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded m-auto h-250px min-w-250px'
                                                style={{ backgroundImage: 'url(' + ((getProductImage(x.node.documentRelations)) as any) + ')' }}
                                            />
                                        </Link>
                                        <div className='m-0 text-center'>
                                            <Link
                                                to={'/productDetail?guid=' + x.node.guid}
                                                className='fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base '>
                                                {x.node.displayName}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const styles = {
    DocumentDiv: {
        display: "flex",
        alignContent: "center",
        justifyContent: "flex-start",
        alignItems: "center"
    }
}